module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306355.6065d8d5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306355.pdf
// module id = 334
// module chunks = 0